import React from "react";
// Local Imports
import { logo } from "@/assets/images";

export const Logo = ({ width, height, className }) => {
  return (
    <div className={`h-20 md:h-[110px] flex justify-center items-center ${className}`}>
      <img src={logo} alt="ILOLA" height={height} width={width || 142} />
    </div>
  );
};
